import gql from 'graphql-tag';

export const Funeral = gql`
    fragment FuneralLegacyDocuments on Funeral {
        LegacyDocuments {
            ... on File {
                ID
                Name
                Size
                AbsoluteLink
            }
            ... on Image {
                ID
                Name
                Size
                AbsoluteLink
            }
        }
    }
`;

export const Prearrangement = gql`
    fragment PrearrangementLegacyDocuments on Prearrangement {
        LegacyDocuments {
            ... on File {
                ID
                Name
                Size
                AbsoluteLink
            }
            ... on Image {
                ID
                Name
                Size
                AbsoluteLink
            }
        }
    }
`;
